import React from 'react';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    onClick,
    type = 'button',
    disabled = false,
    className = ''
}) => {
    const baseStyles = 'font-medium transition-all duration-300 rounded-lg flex items-center justify-center';

    const variants = {
        primary: 'bg-gray-900 text-white hover:bg-gray-800 active:bg-gray-950 disabled:bg-gray-400',
        secondary: 'bg-white text-gray-900 border-2 border-gray-900 hover:bg-gray-900 hover:text-white active:bg-gray-950',
        outline: 'bg-transparent text-gray-900 border border-gray-300 hover:border-gray-900 hover:bg-gray-50',
    };

    const sizes = {
        sm: 'px-4 py-2 text-sm',
        md: 'px-6 py-3 text-base',
        lg: 'px-8 py-4 text-lg',
    };

    const widthClass = fullWidth ? 'w-full' : '';

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
        >
            {children}
        </button>
    );
};

export default Button;
